import { AppService, appService } from './appService';
import { computed } from 'mobx';
import { SchoolOption } from '../domain/SchoolOption';

export class AppModel {
  constructor(private appService: AppService) {}

  @computed
  public get visitedSchools() {
    return this.appService.visitedSchools;
  }

  public set visitedSchools(schools: SchoolOption[]) {
    this.appService.visitedSchools = schools;
  }

  public getSchools = this.appService.getSchools;

  public selectSchool = this.appService.selectSchool;

  public deleteSchool = this.appService.deleteSchool;
}

export const appModel = new AppModel(appService);



// WEBPACK FOOTER //
// ./src/app/appModel.ts